import { useMemo } from "react";
import { TensileColumnDef } from "./useTensileTableCellEditing";

const numericValueParser = (value: string) => {
	const val = Number(value);
	return value === "" || value === null ? null : isNaN(val) ? null : val;
};

export const useTableData = (isEditMode: boolean) => {
	const readOnlyColumnDefs: TensileColumnDef[] = useMemo(
		() => [
			{ field: "SWV", headerName: "SWV", minWidth: 60, align: "center" },
			{ field: "Yield", headerName: "Yield", minWidth: 100, flex: 2 },
			{ field: "Tensile", headerName: "Tensile", minWidth: 100, flex: 2 },
			{ field: "Elongation", headerName: "Elongation", minWidth: 100, flex: 2 },
			{ field: "PercentRA", headerName: "% RA", minWidth: 60 },
			{ field: "Impact", headerName: "Impact", minWidth: 100, flex: 2 },
			{
				field: "TestsPerHeat",
				headerName: "Tests per Heat",
				minWidth: 100,
				flex: 2,
			},
		],
		[],
	);

	const editColumnDefs: TensileColumnDef[] = useMemo(
		() => [
			{
				field: "SWV",
				headerName: "SWV",
				editable: true,
				minWidth: 50,
				valueParser: (value) => {
					const val = Number(value);
					return isNaN(val) ? null : val;
				},
			},
			{
				field: "Yield",
				headerName: "Yield",
				editable: true,
				minWidth: 100,
				flex: 2,
			},
			{
				field: "Tensile",
				headerName: "Tensile",
				editable: true,
				minWidth: 100,
				flex: 2,
			},
			{
				field: "Elongation",
				headerName: "Elongation",
				editable: true,
				minWidth: 100,
				flex: 2,
			},
			{
				field: "PercentRA",
				headerName: "% RA",
				editable: true,
				minWidth: 50,
			},
			{
				field: "Impact",
				headerName: "Impact",
				editable: true,
				minWidth: 100,
				flex: 2,
			},
			{
				field: "TestsPerHeat",
				headerName: "Tests/Heat",
				editable: true,
				minWidth: 80,
				flex: 2,
			},
			{
				field: "Unit",
				headerName: "Unit",
				editable: true,
				minWidth: 50,
				align: "center",
			},
			{
				field: "YieldMin",
				headerName: "Min",
				headerGroup: "Yield",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "YieldMax",
				headerName: "Max",
				headerGroup: "Yield",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "TensileMin",
				headerName: "Min",
				headerGroup: "Tensile",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "TensileMax",
				headerName: "Max",
				headerGroup: "Tensile",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "ElongationPercentMin",
				headerName: "% Min",
				headerGroup: "Elongation",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "ElongationLength",
				headerName: "Length",
				headerGroup: "Elongation",
				editable: true,
				minWidth: 55,
				align: "center",
			},
			{
				field: "PercentRAMin",
				headerName: "Min",
				headerGroup: "% RA",
				editable: true,
				minWidth: 50,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "PercentRAMax",
				headerName: "Max",
				headerGroup: "% RA",
				editable: true,
				minWidth: 50,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "ImpactMin",
				headerName: "Min",
				headerGroup: "Impact",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
			{
				field: "ImpactMax",
				headerName: "Max",
				headerGroup: "Impact",
				editable: true,
				minWidth: 55,
				align: "center",
				valueParser: numericValueParser,
			},
		],
		[],
	);

	const columns = isEditMode ? editColumnDefs : readOnlyColumnDefs;

	return {
		columns,
		readOnlyColumnDefs,
		editColumnDefs,
	};
};
